import React, { Component } from 'react'
import { Button, Card, Col, Form, ListGroup, Modal, Row, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import './ProductList.css'

class ProductList extends Component {
  state = {
    showModal: false,
    isBrandValidated: false,
    isBrandValid: null,
    isModelValidated: false,
    isModelValid: null,
    isSerialValidated: false,
    isSerialValid: null,
    isSubcategoryValidated: false,
    isSubcategoryValid: null,
    approveClaimsTotal: null,
    isProductPurchasePriceValidated: false,
    isProductPurchasePriceValid: null,
  }

  componentDidMount() {
    this.updateProductSubCategories(this.props.productList)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.productList !== this.props.productList) {
      this.updateProductSubCategories(this.props.productList)
    }

    if (
      prevProps?.selectedProduct?.productSequenceNumber !==
      this.props?.selectedProduct?.productSequenceNumber
    ) {
      this.getIndustryDetails()
    }
  }

  updateProductSubCategories = (productList) => {
    productList?.forEach((product) => {
      const { subCategory, modelNumber } = product
      this.props.getProductSubCategory(subCategory, modelNumber, product)
    })
  }

  handleShow = () => {
    this.setState({ showModal: true })
  }

  handleClose = () => {
    this.setState({ showModal: false })
  }

  handleAddProduct = async () => {
    if (this.ValidateModal()) {
      await this.props.handleAddProduct()
      this.handleClose()
      this.resetValidation()
    }
  }

  getVariant = (product) => {
    const { selectedProduct } = this.props
    if (
      selectedProduct?.productSequenceNumber === product?.productSequenceNumber &&
      selectedProduct?.serial === product?.serial &&
      selectedProduct != null
    ) {
      return 'secondary'
    } else {
      return this.product === null ? 'light' : null
    }
  }

  getClass = (product) => {
    const { selectedProduct } = this.props
    return selectedProduct?.productSequenceNumber === product?.productSequenceNumber &&
      selectedProduct?.serial === product?.serial &&
      selectedProduct != null
      ? 'productListItem'
      : 'productListItem text-info'
  }

  renderProducts = () => {
    const { handleProductSelect, isExpired, productList } = this.props

    const sortedList = productList?.sort(
      (a, b) => a.productSequenceNumber - b.productSequenceNumber,
    )

    const { selectedProduct } = this.props

    if (sortedList?.length > 0) {
      return sortedList?.map((product) => {
        const { modelNumber, productSequenceNumber, serial, subCategory } = product

        return (
          <ListGroup.Item
            key={`${productSequenceNumber}${serial}`}
            variant={this.getVariant(product)}
            onClick={isExpired ? null : () => handleProductSelect(product)}
            className={this.getClass(product)}
          >
            {`SEQ#${productSequenceNumber} - ${subCategory} ${modelNumber}`}
          </ListGroup.Item>
        )
      })
    } else {
      return <ListGroup.Item>No products exist.</ListGroup.Item>
    }
  }

  ValidateModal = () => {
    this.setState({
      isBrandValid: this.newBrandInput.value.trim().length === 0 ? false : true,
      isBrandValidated: true,
      isModelValid: this.newModelInput.value.trim().length === 0 ? false : true,
      isModelValidated: true,
      isSerialValid: this.newSerialInput.value.trim().length === 0 ? false : true,
      isSerialValidated: true,
      isSubcategoryValid: this.newSubcategoryInput.value.trim().length === 0 ? false : true,
      isSubcategoryValidated: true,
      isProductPurchasePriceValidated:
        this.newProductPurchasePrice.value.length == 0 ? true : false,
    })

    return (
      this.newBrandInput.value.trim().length > 0 &&
      this.newModelInput.value.trim().length > 0 &&
      this.newSerialInput.value.trim().length > 0 &&
      this.newSubcategoryInput.value.trim().length > 0 &&
      this.newProductPurchasePrice.value.length > 0
    )
  }

  renderAddProductButton = () => {
    const { coverageProductTypeCodeStr, isExpired, loading, productList } = this.props
    const buttonJSX = (
      <div className='d-flex justify-content-end'>
        <Button
          className='RoundedButton'
          variant='outline-info'
          onClick={() => this.handleShow()}
          disabled={loading}
          size='md'
        >
          <FontAwesomeIcon icon={faPlus} /> Add a new product
        </Button>
      </div>
    )
    if (coverageProductTypeCodeStr === 'RSC') {
      if (productList?.length === 0 && !isExpired) {
        return buttonJSX
      }
    } else {
      if (!isExpired) {
        return buttonJSX
      }
    }
  }

  getSubcategoryDisabled = () => {
    return this.props.selectedLossCode ? true : false
  }

  getSubcategoryValue = () => {
    const { newSubcategory, subCategory, selectedLossCode } = this.props
    return selectedLossCode ? subCategory?.subCatCode : newSubcategory
  }

  resetValidation = () => {
    this.setState({
      isBrandValidated: false,
      isModelValidated: false,
      isSerialValidated: false,
      isSubcategoryValidated: false,
    })
  }

  getIndustryDetails = async () => {
    try {
      const { getIndustryDefaultAmount, selectedProduct } = this.props
      if (selectedProduct?.category) {
        const industryAmount = await getIndustryDefaultAmount(selectedProduct?.category)

        this.setState({
          approveClaimsTotal: industryAmount,
        })
      }
    } catch (error) {
      console.log(error, 'error')
    }
  }

  render() {
    const {
      isBrandValid,
      isBrandValidated,
      isModelValid,
      isModelValidated,
      isSubcategoryValid,
      isSubcategoryValidated,
      isSerialValid,
      isSerialValidated,
      showModal,
      isProductPurchasePriceValidated,
      isProductPurchasePriceValid,
    } = this.state

    const {
      condition,
      handleInputChange,
      loading,
      manufacturers,
      newModel,
      newSerial,
      subcategories,
      productPurchasePrice,
    } = this.props
    const { selectedIndustry } = this.props

    const filteredSubcategories = subcategories
      ?.filter((sub) => {
        if (!selectedIndustry) return true
        return sub.catCode === selectedIndustry
      })
      .sort((a, b) => a.subCatCode.localeCompare(b.subCatCode))

    const conditions = [
      { key: 'New', value: 'N' },
      { key: 'Pre-Owned', value: 'U' },
      { key: 'Refurbished', value: 'R' },
      { key: 'Other', value: 'O' },
    ]
    return (
      <React.Fragment>
        {loading && (
          <Row>
            <Col>
              <Spinner animation='border'></Spinner>
              <br />
              <span className='spinner-text'>Re-loading product list...</span>
            </Col>
          </Row>
        )}
        {!loading && (
          <React.Fragment>
            <Card
              style={{
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                marginTop: '10px',
              }}
            >
              <Card.Body className='ProductList'>
                <Row className='ps-3'>
                  <Col xs={3} className='ps-0'>
                    <h4>Products</h4>
                  </Col>
                  <Col xs={6}>
                    <Row>
                      <Col>
                        <b>CLOL Remaining</b> <br />
                        {this.props?.contractLiabilityRemaining}
                      </Col>
                      {this.props?.selectedProduct && (
                        <Col>
                          <b>PLOL Remaining </b>
                          <br />
                          {this.props?.selectedProduct?.liabilityRemaining}
                        </Col>
                      )}
                      <Col>
                        <b>Default Industry </b>
                        <br />
                        {this.state.approveClaimsTotal ?? ''}
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={3} className='float-right' style={{ marginBottom: '0.5rem' }}>
                    {this.renderAddProductButton()}
                  </Col>
                </Row>
                <ListGroup variant='flush'>{this.renderProducts()}</ListGroup>
              </Card.Body>
            </Card>
            <Modal show={showModal} keyboard='false'>
              <Modal.Header>
                <Modal.Title>Add New Product</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group as={Row} controlId='newBrand'>
                  <Form.Label column xs={6}>
                    Manufacturer:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      ref={(element) => (this.newBrandInput = element)}
                      as='select'
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                      className={
                        !isBrandValidated ? null : isBrandValid ? 'is-valid' : 'is-invalid'
                      }
                    >
                      <option value=''>Select manufacturer</option>
                      {manufacturers?.map((mfg) => (
                        <option key={mfg.brand} value={mfg.brand.toUpperCase()}>
                          {mfg.brand.toUpperCase()}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type='invalid'>
                      Please select a manufacturer.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='industry'>
                  <Form.Label column xs={6}>
                    Industry:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      as='select'
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                      value={this.props.selectedIndustry || ''}
                    >
                      <option value=''>Select industry</option>
                      {this.props.industries?.map((ind) => (
                        <option key={ind.industryId} value={ind.industryCode}>
                          {ind.industryName}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='newModel'>
                  <Form.Label column xs={6}>
                    Model Number:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      className={
                        !isModelValidated ? null : isModelValid ? 'is-valid' : 'is-invalid'
                      }
                      ref={(element) => (this.newModelInput = element)}
                      autoComplete='off'
                      type='text'
                      placeholder='Model number'
                      value={newModel}
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                    />
                    <Form.Control.Feedback type='invalid'>
                      Please provide the model number.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='newSubcategory'>
                  <Form.Label column xs={6}>
                    Subcategory:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      className={
                        !isSubcategoryValidated
                          ? null
                          : isSubcategoryValid
                          ? 'is-valid'
                          : 'is-invalid'
                      }
                      ref={(element) => (this.newSubcategoryInput = element)}
                      as='select'
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                      disabled={!selectedIndustry}
                      // disabled={this.getSubcategoryDisabled()}
                      value={this.getSubcategoryValue()}
                    >
                      <option value=''>Select subcategory</option>
                      {filteredSubcategories
                        .slice()
                        .sort((a, b) => a.subCatCode.localeCompare(b.subCatCode))
                        .map((subcategory) => (
                          <option
                            key={`${subcategory.subCatCode.toUpperCase()}${subcategory.subCatDescription.toUpperCase()}`}
                            value={subcategory.subCatCode.toUpperCase()}
                          >
                            {subcategory.subCatCode.toUpperCase()}
                          </option>
                        ))}
                    </Form.Control>
                    <Form.Control.Feedback type='invalid'>
                      Please select a subcategory.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='newSerial'>
                  <Form.Label column xs={6}>
                    Serial:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      className={
                        !isSerialValidated ? null : isSerialValid ? 'is-valid' : 'is-invalid'
                      }
                      ref={(element) => (this.newSerialInput = element)}
                      autoComplete='off'
                      type='text'
                      placeholder='Serial'
                      value={newSerial}
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                    />
                    <Form.Control.Feedback type='invalid'>
                      Please provide a serial.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='condition'>
                  <Form.Label column xs={6}>
                    Condition:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      as='select'
                      size='sm'
                      value={condition}
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                    >
                      {conditions
                        ?.slice()
                        .sort((a, b) => a.key.toLowerCase().localeCompare(b.key.toLowerCase()))
                        .map((condition) => (
                          <option key={condition.key} value={condition.value}>
                            {condition.key}
                          </option>
                        ))}
                    </Form.Control>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId='productPurchasePrice'>
                  <Form.Label column xs={6}>
                    Product purchase price:
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      className={!isProductPurchasePriceValidated ? 'is-valid' : 'is-invalid'}
                      ref={(element) => (this.newProductPurchasePrice = element)}
                      autoComplete='off'
                      type='number'
                      placeholder='Price'
                      value={productPurchasePrice}
                      size='sm'
                      onChange={(event) => {
                        handleInputChange(event)
                      }}
                    />
                    <Form.Control.Feedback type='invalid'>
                      Please add the product purchase price.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={() => this.handleClose()}>
                  Close
                </Button>
                <Button className='btn-green' onClick={() => this.handleAddProduct()}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default ProductList
